export default __webpack_public_path__ + "static/media/hourglass.57043833.png";